import type { SpaceScale, Theme } from '@gousto-internal/citrus-react';
import { withCitrusTheme } from '@gousto-internal/citrus-react';
import { HOME_REDESIGN_BREAKPOINT } from '../tokens';

export type FullBleedContainerStyleProps = React.JSX.IntrinsicElements['div'] & {
  paddingLeftMobile: SpaceScale;
  paddingRightMobile: SpaceScale;
  paddingLeftDesktop: SpaceScale;
  paddingRightDesktop: SpaceScale;
};

function negativeMargin(theme: Theme, space: SpaceScale): string {
  const px = theme.spacing(space) ?? 0;
  return px === 0 ? '0px' : `-${px}px`;
}

export const FullBleedContainer = withCitrusTheme<'div', FullBleedContainerStyleProps>(
  'div',
  (theme, props) => ({
    // No explicit width: with both margins non-auto, a set width would over-constrain the box and drop a margin.
    marginLeft: negativeMargin(theme, props.paddingLeftMobile),
    marginRight: negativeMargin(theme, props.paddingRightMobile),
    [`@media (min-width: ${HOME_REDESIGN_BREAKPOINT})`]: {
      marginLeft: negativeMargin(theme, props.paddingLeftDesktop),
      marginRight: negativeMargin(theme, props.paddingRightDesktop),
    },
  }),
  {
    omitProps: [
      'paddingLeftMobile',
      'paddingRightMobile',
      'paddingLeftDesktop',
      'paddingRightDesktop',
    ],
  },
);
